module.exports = __webpack_public_path__ + "static/img/a2.b56bd9a5.jpg";